"use strict";
var Observable_1 = require('../../Observable');
var publishLast_1 = require('../../operator/publishLast');
Observable_1.Observable.prototype.publishLast = publishLast_1.publishLast;
//# sourceMappingURL=publishLast.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/rxjs/add/operator/publishLast.js
 ** module id = 814
 ** module chunks = 0
 **/